(function() {
  'use strict';

  var cfg = window.QD_RC || {};
  var T = cfg.t || {};
  var locale = cfg.locale || 'en';
  var shouldTranslate = (locale !== 'en');

  var exactMap = {
    'Your cart is empty!': T.cartEmpty,
    'Continue shopping': T.continueShopping,
    'Deliver every': T.deliverEvery,
    '45 day subscription with 25% discount': T.subOption,
    'One-time purchase': T.onetimeOption,
    'Saving 25%': T.saving,
    'Checkout': T.checkout,
    'Upgrade to subscription and save up to 25%': T.upgradeToSub
  };

  var patternMap = [
    {
      regex: /^Your cart \((\d+)\)$/,
      replace: function(m) { return T.yourCart + ' (' + m[1] + ')'; }
    },
    {
      regex: /^Subtotal \((\d+) items?\):$/,
      replace: function(m) {
        var count = parseInt(m[1]);
        if (count === 1) return T.subtotalOne;
        return T.subtotalMulti.replace('{{count}}', count);
      }
    }
  ];

  function translateNode(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var text = node.textContent.trim();
      if (!text) continue;
      if (exactMap[text]) {
        node.textContent = node.textContent.replace(text, exactMap[text]);
        continue;
      }
      for (var i = 0; i < patternMap.length; i++) {
        var match = text.match(patternMap[i].regex);
        if (match) { node.textContent = patternMap[i].replace(match); break; }
      }
    }
    var options = root.querySelectorAll('select option');
    for (var j = 0; j < options.length; j++) {
      var optText = options[j].textContent.trim();
      if (exactMap[optText]) options[j].textContent = exactMap[optText];
    }
    var buttons = root.querySelectorAll('button, a');
    for (var k = 0; k < buttons.length; k++) {
      var btnText = buttons[k].textContent.trim();
      if (exactMap[btnText]) buttons[k].textContent = exactMap[btnText];
      for (var p = 0; p < patternMap.length; p++) {
        var btnMatch = btnText.match(patternMap[p].regex);
        if (btnMatch) { buttons[k].textContent = patternMap[p].replace(btnMatch); break; }
      }
    }
  }

  function findOverlay(shadow) {
    var children = shadow.childNodes;
    for (var i = 0; i < children.length; i++) {
      var n = children[i];
      if (n.nodeType === 1 && n.tagName === 'DIV' && n.className && n.className.indexOf('fixed') > -1 && n.textContent.length > 10) return n;
    }
    return null;
  }

  function findPanel(shadow) {
    var overlay = findOverlay(shadow);
    if (!overlay) return null;
    var headers = overlay.querySelectorAll('header');
    if (headers.length === 0) return null;
    var header = headers[0];
    var panel = header.parentElement;
    if (panel && panel.querySelector('footer')) return panel;
    if (panel && panel.parentElement && panel.parentElement.querySelector('footer')) return panel.parentElement;
    return null;
  }

  function injectStyles(shadow) {
    if (shadow.querySelector('#qd-styles')) return;
    var style = document.createElement('style');
    style.id = 'qd-styles';
    style.textContent = [
      '/* Discount price: black */',
      '[part~="discount"] {',
      '  color: #2A2825 !important;',
      '}',
      '/* Compare price: grey */',
      '.line-through, [part~="compare"] {',
      '  color: #C8C3BA !important;',
      '  font-weight: 400 !important;',
      '}',
      '/* Saving text: sage */',
      '.text-storefront-drawer-accent:not(button):not([name="checkout"]) {',
      '  color: #4A5B4D !important;',
      '}',
      '/* CTA button */',
      'button[name="checkout"] {',
      '  background-color: #2A2825 !important;',
      '  color: #FAFAF8 !important;',
      '  border-radius: 0 !important;',
      '  font-family: "Instrument Sans", system-ui, sans-serif !important;',
      '  font-size: 0.7rem !important;',
      '  font-weight: 600 !important;',
      '  letter-spacing: 0.11em !important;',
      '  text-transform: uppercase !important;',
      '  padding: 1rem !important;',
      '  height: auto !important;',
      '}',
      'button[name="checkout"]:hover {',
      '  background-color: #1A1917 !important;',
      '}',
      '/* Drawer sheet background: off-white */',
      '.bg-background {',
      '  background-color: #FAFAF8 !important;',
      '}',
      '/* Footer totals */',
      'footer .line-through {',
      '  color: #C8C3BA !important;',
      '  font-weight: 400 !important;',
      '}'
    ].join('\n');
    shadow.appendChild(style);
  }

  function updateCTA(shadow) {
    if (!T.ctaSingle) return;
    var buttons = shadow.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var text = buttons[i].textContent.trim();
      if (text === 'Checkout' || text !== T.ctaSingle) {
        buttons[i].textContent = T.ctaSingle;
      }
    }
  }

  function injectTrustBar(shadow) {
    if (!T.trustBar) return;
    var panel = findPanel(shadow);
    if (!panel) return;
    if (panel.querySelector('#qd-trust-bar')) return;
    var header = panel.querySelector('header');
    if (!header) return;
    var bar = document.createElement('div');
    bar.id = 'qd-trust-bar';
    bar.style.cssText = 'padding:10px 24px;background:#D4DDD6;text-align:center;font-family:Instrument Sans,system-ui,sans-serif;font-size:11px;font-weight:500;letter-spacing:0.1em;color:#4A5B4D;text-transform:uppercase;';
    bar.textContent = T.trustBar;
    header.parentNode.insertBefore(bar, header.nextSibling);
  }

  function injectTrustSignals(shadow) {
    if (!T.reviewScore) return;
    var panel = findPanel(shadow);
    if (!panel) return;
    if (panel.querySelector('#qd-trust-signals')) return;
    var footer = panel.querySelector('footer');
    if (!footer) return;
    var container = document.createElement('div');
    container.id = 'qd-trust-signals';
    container.style.cssText = 'padding:8px 24px 12px;text-align:center;';
    var rowStyle = 'display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:4px 14px;margin-bottom:6px;';
    var itemStyle = 'display:inline-flex;align-items:center;gap:5px;font-family:Instrument Sans,system-ui,sans-serif;font-size:11px;letter-spacing:0.06em;text-transform:uppercase;color:#8A8580;';
    var dotSvg = '<svg width="4" height="4" viewBox="0 0 4 4" style="flex-shrink:0"><circle cx="2" cy="2" r="2" fill="#6B7B6E"/></svg>';
    container.innerHTML =
      '<div style="' + rowStyle + '">' +
        '<span style="' + itemStyle + '"><span style="color:#6B7B6E">&#9733;</span> ' + T.reviewScore + '</span>' +
        '<span style="' + itemStyle + '">' + dotSvg + ' ' + T.dermTested + '</span>' +
        '<span style="' + itemStyle + '">' + dotSvg + ' ' + T.delivery + '</span>' +
      '</div>' +
      '<div style="display:flex;align-items:center;justify-content:center;gap:6px;">' +
        '<svg width="11" height="13" viewBox="0 0 12 14" fill="none" style="color:#C8C3BA">' +
          '<rect x="1" y="6" width="10" height="7" rx="1" stroke="currentColor" stroke-width="1.2"/>' +
          '<path d="M3.5 6V4a2.5 2.5 0 0 1 5 0v2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
        '</svg>' +
        '<span style="font-family:Instrument Sans,system-ui,sans-serif;font-size:10px;letter-spacing:0.06em;text-transform:uppercase;color:#C8C3BA;">' + T.ssl + '</span>' +
      '</div>';
    footer.parentNode.insertBefore(container, footer.nextSibling);
  }

  function enhance(shadow) {
    injectStyles(shadow);
    if (shouldTranslate) translateNode(shadow);
    updateCTA(shadow);
    injectTrustBar(shadow);
    injectTrustSignals(shadow);
  }

  function getShadowRoot() {
    var host = document.getElementById('recharge-storefront-experiences__cart-drawer');
    return host ? host.shadowRoot : null;
  }

  function setupObserver() {
    var shadow = getShadowRoot();
    if (!shadow) return false;
    enhance(shadow);
    var timer;
    var obs = new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(function() { enhance(shadow); }, 50);
    });
    obs.observe(shadow, { childList: true, subtree: true, characterData: true });
    return true;
  }

  function init() {
    if (setupObserver()) return;
    var obs = new MutationObserver(function(_, observer) {
      if (setupObserver()) observer.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['recharge:cart-updated', 'cart:updated'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      var shadow = getShadowRoot();
      if (shadow) enhance(shadow);
    });
  });
})();